import { render } from "./ResetRecipe.vue?vue&type=template&id=67579f32&scoped=true"
import script from "./ResetRecipe.vue?vue&type=script&lang=js"
export * from "./ResetRecipe.vue?vue&type=script&lang=js"

import "./ResetRecipe.vue?vue&type=style&index=0&id=67579f32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67579f32"]])

export default __exports__